import Vue from 'vue'
import Vuex from 'vuex'

// Modules
import {modules} from './context/index'; 
import app from './app'
import appConfig from './app-config'
import verticalMenu from './vertical-menu'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    ...modules,
    app,
    appConfig,
    verticalMenu,
  },
  strict: process.env.DEV,
})
